/*
  Cotizador empresas · Guantes de Seguridad
  ─────────────────────────────────────────
  Lista de cotización compartida entre la ficha de producto (snippet gds-cotizador-ficha) y la
  página /pages/cotizacion-empresas (sección gds-cotizador). Se guarda en localStorage del
  navegador del cliente (solo comodidad: si falla, la lista vive en memoria).
  Envía a la Edge Function gds-solicitud-cotizacion (Supabase), que crea el borrador en el ERP.
  Documentación: docs/gds-cotizador.md (repo matriz_ivp_sotval).
*/
(function () {
  if (window.GDSQ) return;
  var KEY = 'gds_cotizacion_v1';
  var URL_FN = 'https://erbgotwqvaglrpqtlxjw.supabase.co/functions/v1/gds-solicitud-cotizacion';
  var PAGINA = '/pages/cotizacion-empresas';
  var memoria = [];

  function leer() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return memoria.slice(); }
  }
  function guardar(lista) {
    memoria = lista.slice();
    try { localStorage.setItem(KEY, JSON.stringify(lista)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('gdsq:cambio', { detail: { lista: lista } }));
    pintarContadores();
  }
  function total(lista) { return (lista || leer()).reduce(function (s, i) { return s + (Number(i.cantidad) || 0); }, 0); }

  // items: [{variant_id, handle, producto, variante, imagen, cantidad}]
  function agregar(items) {
    var lista = leer();
    items.forEach(function (it) {
      var n = Math.floor(Number(it.cantidad));
      if (!(n > 0)) return;
      var previo = lista.find(function (x) { return String(x.variant_id) === String(it.variant_id); });
      if (previo) previo.cantidad = Number(previo.cantidad) + n;
      else lista.push({ variant_id: String(it.variant_id), handle: it.handle, producto: it.producto, variante: it.variante || '', imagen: it.imagen || '', cantidad: n });
    });
    guardar(lista);
    return lista;
  }
  function cambiar(variantId, cantidad) {
    var lista = leer();
    var n = Math.floor(Number(cantidad));
    lista = lista.map(function (x) { if (String(x.variant_id) === String(variantId)) x.cantidad = n; return x; })
      .filter(function (x) { return Number(x.cantidad) > 0; });
    guardar(lista);
  }
  function quitar(variantId) { guardar(leer().filter(function (x) { return String(x.variant_id) !== String(variantId); })); }
  function vaciar() { guardar([]); }

  function pintarContadores() {
    var lista = leer(), n = lista.length;
    document.querySelectorAll('[data-gdsq-contador]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  }

  function aBase64(file) {
    return new Promise(function (ok, mal) {
      var r = new FileReader();
      r.onload = function () { ok(String(r.result).split(',')[1] || ''); };
      r.onerror = function () { mal(new Error('No se pudo leer el archivo')); };
      r.readAsDataURL(file);
    });
  }

  function enviar(datos) {
    var body = Object.assign({}, datos, {
      items: leer().map(function (i) { return { handle: i.handle, variant_id: i.variant_id, cantidad: i.cantidad }; }),
      origen_url: location.href
    });
    return fetch(URL_FN, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok || !x.j.success) throw new Error(x.j.error || 'No pudimos enviar la solicitud. Intenta nuevamente.');
        return x.j;
      });
  }

  window.GDSQ = { leer: leer, agregar: agregar, cambiar: cambiar, quitar: quitar, vaciar: vaciar, total: total, enviar: enviar, aBase64: aBase64, PAGINA: PAGINA, pintarContadores: pintarContadores };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintarContadores); else pintarContadores();
})();
